(function () {
  'use strict';

  if (window.CardMobileGallery) return;

  function initAll(root) {
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll('[data-card-mobile-gallery]').forEach(init);
  }

  function init(gallery) {
    if (gallery.dataset.cardMobileGalleryReady === 'true') return;

    var track = gallery.querySelector('.card__mobile-gallery-track');
    var count = gallery.querySelector('[data-gallery-count]');
    var dots = Array.prototype.slice.call(gallery.querySelectorAll('.card__mobile-gallery-dot'));
    if (!track) return;

    gallery.dataset.cardMobileGalleryReady = 'true';

    var total = dots.length;
    var ticking = false;

    function updateState() {
      if (!total) return;

      var width = track.clientWidth || 1;
      var index = Math.max(0, Math.min(Math.round(track.scrollLeft / width), total - 1));

      if (count) count.textContent = index + 1 + '/' + total;

      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
      });
    }

    track.addEventListener(
      'scroll',
      function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          updateState();
          ticking = false;
        });
      },
      { passive: true }
    );

    window.addEventListener('resize', updateState, { passive: true });
    updateState();
  }

  window.CardMobileGallery = {
    init: init,
    initAll: initAll,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  if (document.body) {
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (!node || node.nodeType !== 1) return;
          if (node.matches && node.matches('[data-card-mobile-gallery]')) {
            init(node);
            return;
          }
          initAll(node);
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }
})();
